let browserLockBypassed = false;
let clientLockPrepared = false;

function installBrowserLockBypass() {
  if (browserLockBypassed) return;

  const locks = typeof navigator !== 'undefined' ? (navigator as any).locks : undefined;
  if (!locks || typeof locks.request !== 'function') return;

  const noOpRequest = async (name: any, optionsOrCallback: any, maybeCallback?: any) => {
    const callback = typeof optionsOrCallback === 'function' ? optionsOrCallback : maybeCallback;
    if (typeof callback !== 'function') return undefined;

    return await callback({ name, mode: 'exclusive' });
  };

  try {
    locks.request = noOpRequest;
  } catch {
    try {
      Object.defineProperty(locks, 'request', {
        configurable: true,
        writable: true,
        value: noOpRequest,
      });
    } catch (error) {
      console.warn('[SupabaseAuthBootstrap] Failed to override navigator.locks.request', error);
      return;
    }
  }

  browserLockBypassed = true;
  console.info('[SupabaseAuthBootstrap] navigator.locks.request bypass installed');
}

installBrowserLockBypass();

export async function prepareSupabaseAuth(): Promise<void> {
  if (clientLockPrepared) return;

  installBrowserLockBypass();

  const { supabase } = await import('@/integrations/supabase/client');
  const auth = (supabase as any)?.auth;

  if (auth && typeof auth.lock === 'function') {
    auth.lock = async <T>(_name: string, _acquireTimeout: number, fn: () => Promise<T>): Promise<T> => {
      return await fn();
    };

    if ('lockAcquireTimeout' in auth) {
      auth.lockAcquireTimeout = 0;
    }

    if (auth?.options) {
      auth.options.lock = false;
      auth.options.lockAcquireTimeout = 0;
    }

    console.info('[SupabaseAuthBootstrap] Supabase auth lock overridden with no-op');
  } else {
    console.warn('[SupabaseAuthBootstrap] Supabase auth lock hook not found; relying on navigator.locks bypass only');
  }

  clientLockPrepared = true;
}